/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, throwError as _throw } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';
import { UserDataService } from '@shared/services';

@Injectable()
export class GuardHelper {
  constructor(private store: Store<fromStore.SharedState>, private userDataService: UserDataService) {}

  checkStore(): Observable<any> {
    return this.store.select(fromStore.getUser).pipe(
      mergeMap((userData: any) => {
        if (!userData.email) {
          // user info not saved in store. Try and use saved Token or re-login
          return this.checkAuthStatus();
        } else {
          return of(userData);
        }
      }),
      filter((loaded) => !!loaded),
      take(1)
    );
  }

  private checkAuthStatus(): Observable<any> {
    const authToken = this.userDataService.getToken();

    if (authToken) {
      return this.validateToken();
    } else {
      return _throw(new Error('Session Expired'));
    }
  }

  private validateToken() {
    return this.userDataService.getUserData();
  }
}
